function ready(callbacks) {
    function runOnReady(fn) {
        const callback = fn || function fakeReady() { };
        function attachEventReady() {
            if (document.readyState !== 'loading') {
                callback();
            }
        }
        if (document.readyState !== 'loading') {
            callback();
        } else if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', callback);
        } else {
            document.attachEvent('onreadystatechange', attachEventReady);
        }
    }

    callbacks.map(runOnReady);
}

module.exports = ready;



// WEBPACK FOOTER //
// ./src/js/ready.js